import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 md:grid-cols-4 gap-4" }
const _hoisted_2 = {
  key: 1,
  class: "text-base font-bold text-gray-900"
}

import { computed } from 'vue'
import {
  mdiAccountCheckOutline,
  mdiOfficeBuildingOutline,
  mdiCardAccountDetailsOutline,
  mdiStethoscope
} from '@mdi/js'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type { DoctorDetailResponse } from '@/Network/Types/Responses/CompanyResponses'
import DoctorStatCard from '../atoms/DoctorStatCard.vue'
import { getActiveStatusConfig, getCrmStatusConfig } from '../../helpers/doctorStatus'


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorSummaryCards',
  props: {
    doctor: {}
  },
  setup(__props: any) {

const props = __props;



// Situação agregada: ativo se houver ao menos um vínculo ativo entre as empresas.
const isActive = computed(() => props.doctor.companies.some((c) => c.isActive))
const activeStatus = computed(() => getActiveStatusConfig(isActive.value))
const companiesCount = computed(() => props.doctor.companies.length)
const crmStatus = computed(() => getCrmStatusConfig(props.doctor.doctor.mainCrm.status))
const specialtiesCount = computed(() => props.doctor.doctor.mainCrm.doctorSpecialties?.length ?? 0)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DoctorStatCard, {
      icon: _unref(mdiAccountCheckOutline),
      label: "Situação",
      "icon-color": activeStatus.value.color === 'green' ? 'green' : 'grey',
      "icon-background": activeStatus.value.color === 'green' ? 'bg-green-50' : 'bg-gray-100',
      "test-id": "doctor-stat-situation"
    }, {
      default: _withCtx(() => [
        _createVNode(LabelBadge, {
          label: activeStatus.value.label,
          color: activeStatus.value.color,
          icon: null,
          size: "small"
        }, null, 8, ["label", "color"])
      ]),
      _: 1
    }, 8, ["icon", "icon-color", "icon-background"]),
    _createVNode(DoctorStatCard, {
      icon: _unref(mdiOfficeBuildingOutline),
      label: "Empresas",
      value: companiesCount.value,
      "icon-color": "primary",
      "test-id": "doctor-stat-companies"
    }, null, 8, ["icon", "value"]),
    _createVNode(DoctorStatCard, {
      icon: _unref(mdiCardAccountDetailsOutline),
      label: "CRM",
      "test-id": "doctor-stat-crm"
    }, {
      default: _withCtx(() => [
        (crmStatus.value)
          ? (_openBlock(), _createBlock(LabelBadge, {
              key: 0,
              label: crmStatus.value.label,
              color: crmStatus.value.color,
              icon: null,
              size: "small"
            }, null, 8, ["label", "color"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, "—"))
      ]),
      _: 1
    }, 8, ["icon"]),
    _createVNode(DoctorStatCard, {
      icon: _unref(mdiStethoscope),
      label: "Especialidades",
      value: specialtiesCount.value,
      "icon-color": "primary",
      "test-id": "doctor-stat-specialties"
    }, null, 8, ["icon", "value"])
  ]))
}
}

})